import styled from "@emotion/styled"
import { spacingFluidMd, spacingFluidXl, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { Grid, GridItem, Skeleton } from "src/components"

export const NotesSkeleton = () => (
	<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }}>
		<GridItem size={{ base: 12, m: 6 }}>
			<Wrapper>
				<Skeleton.Text $width="80px" />
				<Skeleton.Text />
			</Wrapper>
		</GridItem>
	</Grid>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`
